import { NotificationSubscriptionClientData } from "@/model/data/notifications/NotificationSubscriptionClientData";
import { ServiceResponseData } from "../ServiceResponseData";

export class GetNotificationSubscriptionResData extends ServiceResponseData {
    subscriptions: NotificationSubscriptionClientData[] = [];

    constructor(response: any) {
        super(response);

        if (response.data.Payload && response.data.Payload.Subscriptions) {
            response.data.Payload.Subscriptions.forEach((s) => {
                this.subscriptions.push(NotificationSubscriptionClientData.parse(s));
            });
        }
    }
}
